
import { Component, Vue, Prop } from 'vue-property-decorator';
import { toast } from '@/utils/common';
import { postAddGameFile } from '@/api/game-manage';
@Component({})
export default class extends Vue {
  @Prop({ default: '.zip' }) type!: string;
  @Prop({ default: '50' }) size!: string;
  @Prop() rowDate!: any;
  @Prop() file!: any;
  @Prop() uploaderPromise?: any;
  errList: object[] = [];
  fialDialog: boolean = false;
  beforeUpLoad(file: any) {
    this.$emit('startUploadOffLine');
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = async () => {
        let isPass = await this.uploadRules(file);
        if (!isPass) {
          this.$emit('closeOffLineFile');
          reject();
        } else {
          resolve();
        }
      };
      reader.readAsDataURL(file);
    }).then(
      () => {
        return file;
      },
      () => {
        return Promise.reject();
      }
    );
  }
  uploadRules(file: any) {
    return new Promise(resolve => {
      const isLt2M = file.size / 1024 / 1024 < Number(this.size);
      const isType = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
      let istype = this.type.includes(`${isType}`);
      if (!istype) {
        this.$message.error(`文件格式仅支持 ${this.type} 格式，请重新上传`);
        resolve(false);
      }
      if (!isLt2M) {
        this.$message.error(`文件大小不能超过${this.size}MB`);
        resolve(false);
      }
      resolve(true);
    });
  }
  UploadFile(file: any) {
    this.$msgbox({
      title: '提示',
      message: '确认要导入吗？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          const params = new FormData();
          params.append('file', file.file);
          params.append('bucket', '');
          let res: any = await postAddGameFile(params);
          // const IsFail: boolean = res.data.fail_list.length > 0 ? true : false;
          const { code, msg, data } = res;
          if (res && code == 0) {
            this.$emit('uploadOffLineFileSuccess', data, this.rowDate);
            // toast('操作成功!');
          } else {
            this.errList = msg;
            this.fialDialog = true;

            //   toast(JSON.stringify(errValue), 'error');
          }
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(action => {})
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.$emit('closeOffLineFile');
      });
  }
  mounted() {}
}
